

export const LOGIN_URL = 'https://fnpq9f4rf4.execute-api.eu-north-1.amazonaws.com/dev/login';
export const REGISTER_URL = 'https://fnpq9f4rf4.execute-api.eu-north-1.amazonaws.com/dev/register';
export const SUBMIT_FORM_URL = 'https://fnpq9f4rf4.execute-api.eu-north-1.amazonaws.com/dev/submit-form';
export const APPLICATIONS_URL = 'https://fnpq9f4rf4.execute-api.eu-north-1.amazonaws.com/dev/applications';
export const VERIFICATION_URL = 'https://fnpq9f4rf4.execute-api.eu-north-1.amazonaws.com/dev/verify/';
export const PAYMENT_URL = 'https://nestuge.com/mnbnnkkiz';
// export const PAYMENT_URL = 'https://selar.com/799803';

